



























import { Prop, Component, Vue } from "vue-property-decorator";
import { ProjectMemberCardProps } from "@/decorators/project-member-card-decorator";
import ProjectMemberCard from "./ProjectMemberCard.vue";

@Component({
  components: {
    ProjectMemberCard
  },
  model: {
    prop: "selected"
  }
})
export default class ProjectMemberSelect extends Vue {
  @Prop({ default: () => [] }) selected!: string[];
  @Prop({ default: () => [] }) options!: ProjectMemberSelectOption;

  input(selected: string[]) {
    this.$emit("input", selected);
  }
}

export interface ProjectMemberSelectOption {
  value: string;
  member: ProjectMemberCardProps;
  selected: boolean;
}
